/**
 * UI elements
 */
class UI {
    constructor() {
        this.initCheckWindows();
        this.initFormPopup();
        this.initClosePopups();
        this.initTextareaCounter();
        this.initViewImageInputFile();
        this.initViewImageInputFileMultiple();
        // this.initShowFaq();
        this.initOpenTooltip();
    }

    initCheckWindows() {
        let userAgent = window.navigator.userAgent;
        let platform = window.navigator.platform;

        if (platform.includes("Win")) {
            $(document.body).addClass('has-win');
        }
    }

    initFormPopup() {
        this.formPopup = $('.popup-block-form');

        document.body.addEventListener('click', e => {
            if (e.target.tagName === 'A' && e.target.getAttribute('href') === '#OpenFormPopup') {
                e.preventDefault();
                $('form').each(function () {
                    this.reset();
                    $('#previewContainer').empty();
                    $('#deleteFileInput').addClass('is-hidden');
                    $('#previewMultipleContainer').empty();
                    $('#deleteFileMultipleInput').addClass('is-hidden');
                });
                this.formPopup.removeClass('is-hidden');
                $(document.body).addClass('no-scroll');
            }
        });
    }

    initClosePopups() {
        let popups = $('.popup-block');

        if (!popups.length) {
            return
        }

        for (let i = 0; i < popups.length; i++) {
            let closeBtn = popups.eq(i).find('.close-popup');

            closeBtn.on('click', (e) => {
                e.preventDefault();
                location.reload();
            });

            document.body.addEventListener('click', e => {
                if (e.target.tagName === 'A' && e.target.getAttribute('href') === '#btn-ok-close-popup') {
                    e.preventDefault();
                    location.reload();
                }
            });

            document.body.addEventListener('click', e => {
                if (e.target.tagName === 'A' && e.target.getAttribute('id') === 'btnCloseForm') {
                    e.preventDefault();
                    popups.eq(i).addClass('is-hidden');
                    $(document.body).removeClass('no-scroll');

                    $('form').each(function () {
                        this.reset();
                        $('#previewContainer').empty();
                        $('#deleteFileInput').addClass('is-hidden');
                        $('#previewMultipleContainer').empty();
                        $('#deleteFileMultipleInput').addClass('is-hidden');
                    });

                    $('#formStep1').removeClass('hide');
                    $('#formStep2').addClass('hide');
                    $('#formStep3').addClass('hide');
                    $('#formStep4').addClass('hide');
                    $('#formStep5').addClass('hide');
                }
            });
        }
    }

    initTextareaCounter() {
        document.body.addEventListener('click', e => {
            if (e.target.tagName === 'TEXTAREA' && e.target.classList.contains('complaint_comment')) {
                $('#complaint_comment').on('keyup', (e) => {
                    let textareaCounter = $(e.target).parents('.form-item').find('.textarea-counter');
                    let maxChars = 255;

                    let remaining = maxChars - $(e.target).val().length;
                    textareaCounter.text('Pozostało ' + remaining + ' znaków')
                });
            }
        });
    }

    initViewImageInputFile() {
        let inputFile = $('#fileInput');
        let deleteFile = $('#deleteFileInput');
        const previewContainer = $('#previewContainer');

        if (!inputFile.length) {
            return
        }

        document.body.addEventListener('click', e => {
            if (e.target.tagName === 'A' && e.target.getAttribute('href') === '#deleteFileInput') {
                e.preventDefault();
                inputFile.val('');
                previewContainer.empty();
                deleteFile.addClass('is-hidden');
            }
        });

        inputFile.on('change', function (e) {
            const files = this.files;
            let errorMessage = $('#fileInput').parents('.form-item').find('.validation-error');
            previewContainer.empty();
            deleteFile.addClass('is-hidden');
            errorMessage.text('');
            let maxSize = parseInt($(e.target).attr('data-max-size'), 10) * 1000000;

            if (this.files[0].size > maxSize) {
                $(this).val('');
                previewContainer.empty();
                deleteFile.addClass('is-hidden');

                errorMessage.text('Plik jest za duży! Maksymalny rozmiar to ' + (maxSize / 1000000) + 'MB.');
            }

            $.each(files, function (index, file) {
                if (file.type.startsWith('image/')) {
                    const reader = new FileReader();

                    reader.onload = function (e) {
                        const fileImages = $('<img>')
                            .attr('src', e.target.result)
                            .css({
                                'max-width': '100px',
                                'max-height': '100px',
                                'border-radius': '8px',
                                'object-fit': 'cover',
                                'box-shadow': '0 2px 4px rgba(0, 0, 0, 0.2)'
                            });

                        previewContainer.append(fileImages);
                        deleteFile.removeClass('is-hidden');
                    };

                    reader.readAsDataURL(file);
                }
            });
        });
    }

    initViewImageInputFileMultiple() {
        document.body.addEventListener('click', e => {
            if (e.target.tagName === 'A' && e.target.getAttribute('href') === '#deleteFileMultipleInput') {
                e.preventDefault();
                $('#MultipleFileInput').val('');
                $('#previewMultipleContainer').empty();
                $('#deleteFileMultipleInput').addClass('is-hidden');
            }
        });

        document.body.addEventListener('click', e => {
            if (e.target.tagName === 'INPUT' && e.target.getAttribute('id') === 'MultipleFileInput') {
                let inputFile = $(e.target);

                inputFile.on('change', function () {
                    let files = e.target.files;
                    let previewContainer = $(e.target).parent().find('#previewMultipleContainer');
                    let deleteFile = $(e.target).parent().find('#deleteFileMultipleInput');

                    let errorMessage = $('#MultipleFileInput').parents('.form-item').find('.validation-error');
                    previewContainer.empty();
                    deleteFile.addClass('is-hidden');
                    errorMessage.text('');
                    let maxSize = parseInt($(e.target).attr('data-max-size'), 10) * 1000000;

                    let oversizedFiles = [];
                    let validFiles = [];

                    for (let i = 0; i < files.length; i++) {
                        if (files[i].size > maxSize) {
                            oversizedFiles.push(files[i].name);
                        } else {
                            validFiles.push(files[i]);
                        }
                    }

                    $.each(validFiles, function (index, file) {
                        if (file.type.startsWith('image/')) {
                            const reader = new FileReader();

                            reader.onload = function (e) {
                                const fileImages = $('<img>')
                                    .attr('src', e.target.result)
                                    .css({
                                        'max-width': '100px',
                                        'max-height': '100px',
                                        'border-radius': '8px',
                                        'object-fit': 'cover',
                                        'box-shadow': '0 2px 4px rgba(0, 0, 0, 0.2)'
                                    });
                                previewContainer.append(fileImages);
                                deleteFile.removeClass('is-hidden');
                            };

                            reader.readAsDataURL(file);
                        }
                    });

                    if (oversizedFiles.length > 0) {
                        $(e.target).val('');
                        deleteFile.addClass('is-hidden');

                        errorMessage.text('Następujące pliki są za duże: ' + oversizedFiles.join(', ') +
                            '. Maksymalny rozmiar to ' + (maxSize / 1000000) + 'MB.');
                    }
                });
            }
        });
    }

    initShowFaq() {
        let faqList = $('.faq-accordion-list');
        let faqItem = faqList.find('.faq-accordion-item');
        let showAllBtn = $('.btn-open-faq');

        if (!faqList.length) {
            return
        }

        showAllBtn.on('click', (e) => {
            e.preventDefault();
            faqItem.removeClass('is-hidden');
            showAllBtn.addClass('is-hidden');
        });
    }

    initOpenTooltip() {
        let tooltips = $('.tooltip');

        for (let i = 0; i < tooltips.length; i++) {
            tooltips.eq(i).on('click', e => {
                e.preventDefault();
                let tooltipIsActive = $(e.target).parent().hasClass('is-active');
                tooltips.removeClass('is-active');

                if (!tooltipIsActive) {
                    $(e.target).parent().addClass('is-active');
                }
            });

            let tooltipBtn = tooltips.eq(i).find('a');

            tooltipBtn.on('click', e => {
                e.stopPropagation();
            });
        }
    }
}
